import React, { useState, useContext, useEffect } from 'react';
import { Card, Form, Button, Row, Col, Tabs, Tab } from 'react-bootstrap';
import { ProductContext } from '../../ProductProvider';
import { useSnackbar } from 'notistack';
import { fetchAuthSession } from 'aws-amplify/auth';
import axios from 'axios';
import {Helmet} from 'react-helmet-async';
//import JournalIssues from './JournalIssues';

const config = require('../../config.json');

// Modern form styles with improved UX
const journalFormStyles = `
  .journal-section {
    background: linear-gradient(135deg, #f8fafc 0%, #e0e7ef 100%);
    min-height: 100vh;
    padding: 40px 0 60px 0;
    font-family: Inter, Segoe UI, Arial, sans-serif;
  }
  .journal-card {
    border-radius: 18px !important;
    box-shadow: 0 4px 16px 0 rgba(44, 62, 80, 0.08);
    border: none !important;
    margin-bottom: 2rem;
    background: #fff !important;
    transition: box-shadow 0.2s;
  }
  .journal-card:hover {
    box-shadow: 0 8px 32px 0 rgba(44, 62, 80, 0.12);
  }
  .journal-title {
    font-size: 1.8rem;
    font-weight: 800;
    color: #2a3659;
    margin-bottom: 1.5rem;
    text-align: center;
    letter-spacing: 0.5px;
  }
  .journal-form-label {
    font-weight: 600;
    color: #2a3659;
    margin-bottom: 0.3rem;
  }
  .journal-form input,
  .journal-form select,
  .journal-form textarea {
    border-radius: 10px;
    border: 1.5px solid #e3eafc;
    padding: 0.6rem 1rem;
    font-size: 0.95rem;
    background: #fafdff;
    transition: all 0.2s;
    box-shadow: 0 2px 8px 0 rgba(44, 62, 80, 0.06);
  }
  .journal-form input:focus,
  .journal-form select:focus,
  .journal-form textarea:focus {
    border-color: #4f8cff;
    box-shadow: 0 4px 16px 0 rgba(79, 140, 255, 0.1);
    outline: none;
  }
  .journal-btn {
    background: linear-gradient(90deg, #4f8cff 0%, #6ed0fa 100%);
    color: #fff;
    border: none;
    border-radius: 10px;
    padding: 12px 32px;
    font-size: 1.1rem;
    font-weight: 600;
    box-shadow: 0 2px 8px 0 rgba(44, 62, 80, 0.1);
    transition: all 0.2s;
    margin-top: 10px;
    width: 100%;
    max-width: 320px;
  }
  .journal-btn:hover, .journal-btn:focus {
    background: linear-gradient(90deg, #063547 60%, #7ee8fa 100%);
    color: #fff;
    transform: translateY(-2px);
    box-shadow: 0 4px 16px 0 rgba(44, 62, 80, 0.15);
  }
  .journal-btn:disabled {
    background: #e3eafc;
    cursor: not-allowed;
    transform: none;
  }
  @media (max-width: 768px) {
    .journal-section {
      padding: 20px 0 30px 0;
    }
    .journal-title {
      font-size: 1.5rem;
    }
    .journal-form input,
    .journal-form select,
    .journal-form textarea {
      font-size: 0.9rem;
      padding: 0.5rem 0.8rem;
    }
    .journal-btn {
      font-size: 1rem;
      padding: 10px 24px;
    }
  }
`;

export default function JournalForm(props) {
  const { validateLogin, loggedUser, generateUUIDNo, journalData, setJournalData } = useContext(ProductContext);
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState('details');
  const [submittedJournal, setSubmittedJournal] = useState(null);
  const {viewOnly, formType, setTabIssues} = props;

  useEffect(() => {
    if(formType === 'New'){
      setJournalData({
                  journalID: null,
                  journalType: 'Journal',
                  journalTitle: '',
                  subtitle: '',
                  issn: '',
                  publisher: '',
                  frequency: 'Monthly',
                  journalSubject: '',
                  journalLanguage: 'English',
                  startYear: '',
                  journalStatus: 'Active',
                  description: '',
                  subscriptionType: 'Print',
                  journalPrice: '0',
                  website: '',
                  liblocation: '',
                  country: 'India',
                  delivery: 'Post',
                  journalKeywords: 'NA',
                  contactNo: '',
                  emailID: '',
                  subscriptionNo: '',
                  subscriptionModal:'Exchange'
                });
              }
  }, []);

 const handleUpdate = async (event) => {
    event.preventDefault();
    try {
      const validationResult = validateFields();
      if (validationResult === "failed") {
        return;
      }

      setLoading(true);
      
      // Generate unique journal ID 
      const params = {
        ...journalData,
        clientID: loggedUser.website,
        updatedBy: loggedUser.nickname,
        updatedOn: new Date().toISOString()
      };  
      //console.log('Updating journal data:', params);
      const { idToken } = (await fetchAuthSession()).tokens ?? {};
      await axios.patch(`${config.api.invokeURL}/vjlibrary/journal/catalogue`, params, {
        headers: {
          Authorization: idToken,
          'x-api-key': config.api.key
        }
      });
      enqueueSnackbar('Journal updated successfully!', { variant: 'success' });
      setSubmittedJournal(params);
      setActiveTab('issues');
    } catch (error) {
      console.error('Error:', error);
      enqueueSnackbar(`Error: ${error.message}`, { variant: 'error' });
    }
    finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const validationResult = validateFields();
      if (validationResult === "failed") {
        return;
      }
      setLoading(true);
      const params = {
        ...journalData,
        clientID: loggedUser.website,
        updatedBy: loggedUser.nickname,
        updatedOn: new Date().toISOString()
      };
      //console.log('Submitting journal data:', params);
      const { idToken } = (await fetchAuthSession()).tokens ?? {};
      await axios.post(`${config.api.invokeURL}/vjlibrary/journal/catalogue`, params, {
        headers: {
          Authorization: idToken,
          'x-api-key': config.api.key
        }
      });
      enqueueSnackbar('Journal added successfully!', { variant: 'success' });
      setSubmittedJournal(params);
      setTabIssues(false);
      setActiveTab('issues');
    } catch (error) {
      //console.error('Error:', error);
      enqueueSnackbar(`Error: ${error.message}`, { variant: 'error' });
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    var tvalue=value;
    if(name === 'journalTitle' || name === 'subtitle' || name === 'publisher' || name === 'journalSubject' || name === 'country'){
      tvalue=value.toUpperCase();
    }
    setJournalData(prev => ({
      ...prev,
      [name]: tvalue.toUpperCase()
    }));
  };

  const validateFields = () => {
    var returnValue="passed";
    if(!journalData.journalID || journalData.journalID.trim() === ''){
          enqueueSnackbar("Journal ID is mandatory.",{variant : 'info'});
          returnValue="failed";
    }else if(!journalData.journalTitle || journalData.journalTitle.trim() === ''){
          enqueueSnackbar("Journal Title is mandatory.",{variant : 'info'});
          returnValue="failed";
    }else if(!journalData.journalType || journalData.journalType.trim() === ''){
          enqueueSnackbar("Journal Type is mandatory.",{variant : 'info'});
          returnValue="failed";
    }else if(!journalData.publisher || journalData.publisher.trim() === ''){
          enqueueSnackbar("Journal Publisher is mandatory.",{variant : 'info'});
          returnValue="failed";
    }else {
      returnValue="passed";
      }
    return returnValue;
    }


  return (
    <div className="journal-section">
      <style>{journalFormStyles}</style>
      <Helmet>
        <title>Add Journal - Library - Vidyajyoti College of Theology</title>
        <meta name="description" content="Add new journals to the library catalog" />
      </Helmet>

      <div className="container">
        <Card className="journal-card">
          <Card.Body className="p-4">
            {/*<h2 className="journal-title">Journal Management</h2>*/}
            
                <Form className="journal-form" onSubmit={handleSubmit}>
                  <Row className="mb-4">
                  <Col md={4}>
                  <Form.Group>
                    <Form.Label className="journal-form-label">Journal ID *</Form.Label>
                    <Form.Control
                      type="text"
                      name="journalID"
                      value={journalData.journalID}
                      onChange={handleChange}
                      required
                      placeholder="Enter Journal ID"
                      disabled={viewOnly}
                    />
                  </Form.Group>
                </Col>
                 <Col md={8}>
                  <Form.Group>
                    <Form.Label className="journal-form-label">Journal Title *</Form.Label>
                    <Form.Control
                      type="text"
                      name="journalTitle"
                      value={journalData.journalTitle}
                      onChange={handleChange}
                      required
                      placeholder="Enter journal title"
                      disabled={viewOnly}
                    />
                  </Form.Group>
                </Col>
               
                </Row>
              <Row className="g-3">
                <Col md={4}>
                  <Form.Group>
                    <Form.Label className="journal-form-label">ID Type *</Form.Label>
                    <Form.Select
                      name="journalType"
                      value={journalData.journalType}
                      onChange={handleChange}
                      required
                      disabled={viewOnly}
                    >
                      <option value="Journal">Journal</option>
                      <option value="Bound Journal">Bound Journal</option>
                      <option value="Magazine">Magazine</option>
                      <option value="Newspaper">Newspaper</option>
                      <option value="Newsletter">Newsletter</option>
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col md={8}>
                  <Form.Group>
                    <Form.Label className="journal-form-label">Subtitle</Form.Label>
                    <Form.Control
                      type="text"
                      name="subtitle"
                      value={journalData.subtitle}
                      onChange={handleChange}
                      placeholder="Enter subtitle (if any)"
                      disabled={viewOnly}
                    />
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group>
                    <Form.Label className="journal-form-label">ISSN *</Form.Label>
                    <Form.Control
                      type="text"
                      name="issn"
                      value={journalData.issn}
                      onChange={handleChange}
                      required
                      placeholder="XXXX-XXXX"
                      pattern="[0-9]{4}-[0-9]{4}"
                      disabled={viewOnly}
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group>
                    <Form.Label className="journal-form-label">Publisher *</Form.Label>
                    <Form.Control
                      type="text"
                      name="publisher"
                      value={journalData.publisher}
                      onChange={handleChange}
                      required
                      placeholder="Publisher name"
                      disabled={viewOnly}
                    />
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group>
                    <Form.Label className="journal-form-label">Frequency</Form.Label>
                    <Form.Select
                      name="frequency"
                      value={journalData.frequency}
                      onChange={handleChange}
                      disabled={viewOnly}
                    >
                      <option value="Weekly">Weekly</option>
                      <option value="Biweekly">Biweekly</option>
                      <option value="Monthly">Monthly</option>
                      <option value="Bimonthly">Bimonthly</option>
                      <option value="Quarterly">Quarterly</option>
                      <option value="Triannual">Triannual</option>
                      <option value="Biannual">Biannual</option>
                      <option value="Annual">Annual</option>
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group>
                    <Form.Label className="journal-form-label">Subject Area *</Form.Label>
                    <Form.Control
                      type="text"
                      name="journalSubject"
                      value={journalData.journalSubject}
                      onChange={handleChange}
                      required
                      placeholder="Main subject/category"
                      disabled={viewOnly}
                    />
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group>
                    <Form.Label className="journal-form-label">Language</Form.Label>
                    <Form.Select
                      name="journalLanguage"
                      value={journalData.journalLanguage}
                      onChange={handleChange}
                      disabled={viewOnly}
                    >
                      <option value="English">English</option>
                      <option value="Hindi">Hindi</option>
                      <option value="Other">Other</option>
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group>
                    <Form.Label className="journal-form-label">Start Year *</Form.Label>
                    <Form.Control
                      type="number"
                      name="startYear"
                      value={journalData.startYear}
                      onChange={handleChange}
                      required
                      min="1800"
                      max={new Date().getFullYear()}
                      placeholder="YYYY"
                      disabled={viewOnly}
                    />
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group>
                    <Form.Label className="journal-form-label">Status</Form.Label>
                    <Form.Select
                      name="journalStatus"
                      value={journalData.journalStatus}
                      onChange={handleChange}
                      disabled={viewOnly}
                    >
                      <option value="Active">Active</option>
                      <option value="Discontinued">Discontinued</option>
                      <option value="On Hold">On Hold</option>
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group>
                    <Form.Label className="journal-form-label">Subscription Type</Form.Label>
                    <Form.Select
                      name="subscriptionType"
                      value={journalData.subscriptionType}
                      onChange={handleChange}
                      disabled={viewOnly}
                    >
                      <option value="Print">Print</option>
                      <option value="Online">Online</option>
                      <option value="Print + Online">Print + Online</option>
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group>
                    <Form.Label className="journal-form-label">Price</Form.Label>
                    <Form.Control
                      type="number"
                      name="journalPrice"
                      value={journalData.journalPrice}
                      onChange={handleChange}
                      min="0"
                      step="0.01"
                      placeholder="Subscription price"
                      disabled={viewOnly}
                    />
                  </Form.Group>
                </Col>
                 <Col md={4}>
                  <Form.Group>
                    <Form.Label className="journal-form-label">Contact No</Form.Label>
                    <Form.Control
                      type="text"
                      name="contactNo"
                      value={journalData.contactNo}
                      onChange={handleChange}
                      placeholder="Journal contact number"
                      disabled={viewOnly}
                    />
                  </Form.Group>
                </Col>
 <Col md={4}>
                  <Form.Group>
                    <Form.Label className="journal-form-label">Email ID</Form.Label>
                    <Form.Control
                      type="text"
                      name="emailID"
                      value={journalData.emailID}
                      onChange={handleChange}
                      placeholder="Email ID"
                      disabled={viewOnly}
                    />
                  </Form.Group>
                </Col>
 <Col md={4}>
                  <Form.Group>
                    <Form.Label className="journal-form-label">Subscription No</Form.Label>
                    <Form.Control
                      type="text"
                      name="subscriptionNo"
                      value={journalData.subscriptionNo}
                      onChange={handleChange}
                      placeholder="Subscription Number"
                      disabled={viewOnly}
                    />
                  </Form.Group>
                </Col>
 <Col md={4}>
                  <Form.Group>
                    <Form.Label className="journal-form-label">Subscription Modal</Form.Label>
                    <Form.Control
                      type="text"
                      name="subscriptionModal"
                      value={journalData.subscriptionModal}
                      onChange={handleChange}
                      placeholder="Subscription Modal"
                      disabled={viewOnly}
                    />
                  </Form.Group>
                </Col>

                  <Col md={4}>
                  <Form.Group>
                    <Form.Label className="journal-form-label">Location</Form.Label>
                    <Form.Control
                      type="text"
                      name="liblocation"
                      value={journalData.liblocation}
                      onChange={handleChange}
                      placeholder="Library location or section"
                      disabled={viewOnly}
                    />
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group>
                    <Form.Label className="journal-form-label">Country</Form.Label>
                    <Form.Control
                      type="text"
                      name="country"
                      value={journalData.country}
                      onChange={handleChange}
                      placeholder="Country of publication"
                      disabled={viewOnly}
                    />
                  </Form.Group>
                </Col>

                <Col md={4}>
                  <Form.Group>
                    <Form.Label className="journal-form-label">Delivery</Form.Label>
                    <Form.Control
                      type="text"
                      name="delivery"
                      value={journalData.delivery}
                      onChange={handleChange}
                      placeholder="Delivery method or details"
                      disabled={viewOnly}
                    />
                  </Form.Group>
                </Col>

                 <Col md={4}>
                  <Form.Group>
                    <Form.Label className="journal-form-label">Website</Form.Label>
                    <Form.Control
                      type="url"
                      name="website"
                      value={journalData.website}
                      onChange={handleChange}
                      placeholder="Journal or publisher website"
                      disabled={viewOnly}
                    />
                  </Form.Group>
                </Col>

                <Col md={12}>
                  <Form.Group>
                    <Form.Label className="journal-form-label">Description</Form.Label>
                    <Form.Control
                      as="textarea"
                      name="description"
                      value={journalData.description}
                      onChange={handleChange}
                      rows={3}
                      disabled={viewOnly}
                      placeholder="Journal description, scope, or additional details"
                    />
                  </Form.Group>
                </Col>
                {formType === 'New' ? <Col md={12} className="text-center mt-4">
                  <Button
                    type="submit"
                    className="journal-btn"
                    disabled={loading}
                    onClick={handleSubmit}
                  >
                    {loading ? 'Adding Journal...' : 'Add Journal'}
                  </Button>
                </Col>:formType === 'Edit' ? <Col md={12} className="text-center mt-4">
                  <Button
                    type="submit"
                    className="journal-btn"
                    disabled={loading}
                    onClick={handleUpdate}
                  >
                    {loading ? 'Updating Journal...' : 'Update Journal'}
                  </Button>
                </Col>: null}
              </Row>
            </Form>
            {/*<Tabs
              activeKey={activeTab}
              onSelect={(k) => setActiveTab(k)}
              className="mb-4 journal-tabs"
              justify
            >
              <Tab 
                eventKey="issues" 
                title={<span><i className="fa fa-list"></i> Journal Issues</span>}
                disabled={!submittedJournal}
              >
                {submittedJournal && (
                  <JournalIssues 
                    journalId={submittedJournal.journalId}
                    frequency={submittedJournal.frequency}
                  />
                )}
              </Tab>
            </Tabs>*/}
          </Card.Body>
        </Card>
      </div>
    </div>
  );
}
